/**
 * Freemium signup constants shared by the web app, the landing app and the backend.
 */

/** Andrew Ackerman's "Fundamentals of Raising Money from VCs": lesson 1 is the free preview a new member lands on. */
export const FIRST_LESSON_COURSE_SLUG = 'fundamentals-of-raising-money-from-vcs';

/**
 * How long a new email-and-password account keeps full access before it must confirm its email. The confirmation link
 * is sent at signup; the member is never held up by it inside this window. Google and LinkedIn accounts arrive verified.
 */
export const EMAIL_VERIFICATION_GRACE_DAYS = 14;

const MILLISECONDS_PER_DAY = 86_400_000;

/** Whether an unverified account is still inside its grace window, counted from when it was created. */
export function isWithinEmailVerificationGrace(createdAt: Date | string | number, now: Date = new Date()): boolean {
  const createdAtMs = new Date(createdAt).getTime();
  if (Number.isNaN(createdAtMs)) return false;
  const ageMs = now.getTime() - createdAtMs;
  // A creation time in the future is a bad timestamp, never a reason to extend access.
  if (ageMs < 0) return false;
  return ageMs < EMAIL_VERIFICATION_GRACE_DAYS * MILLISECONDS_PER_DAY;
}
